import {createHashRouter, RouterProvider} from "react-router-dom";
import ApplyLogin from "./pages/loginPage";

const Router = () => {
  const router = createHashRouter([
    {
      path: "/*",
      element: <ApplyLogin />,
    },
  ]);
  return <RouterProvider router={router} />;
};

export default Router;
